<template>
  <div class="pravo">
    <PravoTop Image="purchaseData" Header="Purchase data" />

    <div class="pravo__obsah">
      <div class="pravo__buttons">
        <GoBack
          href="/game/GameOverview"
          icon="gameOverview"
          text="Back to game overview"
        />
      </div>

      <div class="grid">
        <PurchasedData TableWidth="full" />
        <DataProductTable typeTable="demography" TableWidth="half" />
        <DataProductTable typeTable="quantitative" TableWidth="half" />
        <DataProductTable typeTable="qualitative" TableWidth="half" />
        <DataProductTable typeTable="products" TableWidth="half" />
        <DataProductTable typeTable="effectivity" TableWidth="half" />
      </div>
    </div>
  </div>
</template>

<script>
import PravoTop from "@/components/game/pravo/PravoTop.vue";
import DataProductTable from "@/components/game/table/tables/DataProductTable.vue";
import GoBack from "@/components/game/pravo/GoBack.vue";
import PurchasedData from "@/components/game/table/tables/PurchasedData";

export default {
  name: "PurchaseData",
  components: {
    PravoTop,
    GoBack,
    DataProductTable,
    PurchasedData,
  },
};
</script>

